import { Button, Text } from '@my/ui'

export interface ReactionItemProps {
  name: string
  Icon: string
  isActive: boolean
  onPress: () => void
}

export const ReactionItem = (props: ReactionItemProps) => {
  return (
    <Button
      size="$2"
      px="$1"
      aria-label={`React with ${props.name}`}
      plain
      onPress={props.onPress}
      animation={[
        'quick',
        {
          scale: {
            overshootClamping: true,
          },
        },
      ]}
      hoverStyle={{ scale: 1.2 }}
      pressStyle={{ scale: 0.9 }}
      focusStyle={{ scale: 1.2 }}
      {...(props.isActive && {
        bg: '$overlay4',
      })}
    >
      <Text fontSize="$8" lineHeight="$5">
        {props.Icon}
      </Text>
    </Button>
  )
}
